module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/acoustic-1a08497793041ff5134ce076b84ecde1.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/acoustic.svg
// module id = MYfG
// module chunks = 24